/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { useRecoilValue } from "recoil";
import { websiteDataState } from "helpers/recoil";
// const websiteData = useRecoilValue(websiteDataState)

function SectionDark() {
    const websiteData = useRecoilValue(websiteDataState)
    return (
        <>
            <div className="section section-dark" style={{ 
                padding: "80px 0",
                background: "linear-gradient(135deg, #00adee 0%, #0096cc 100%)",
                boxShadow: "0 10px 40px rgba(0, 173, 238, 0.2)"
            }}>
                <Container>
                    <Row>
                        <Col className="ms-auto me-auto text-center" md="10" lg="9">
                            <h2 className="title" style={{ 
                                fontSize: "36px", 
                                fontWeight: "700",
                                color: "#FFFFFF",
                                marginBottom: "40px",
                                textShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                                letterSpacing: "-0.5px",
                                lineHeight: "1.2"
                            }}>{websiteData?.snippetsDictionary?.['section-header-specialisaties']?.text}</h2>
                            <Row style={{ paddingTop: "30px" }}>
                                <div style={{ 
                                    display: "flex", 
                                    flexWrap: "wrap", 
                                    gap: "15px",
                                    justifyContent: "center"
                                }}>
                                    {(websiteData?.snippetsDictionary?.['section-body-specialisaties']?.text || "")
                                        .split(",")
                                        .map((item, index) =>
                                            <div key={index} style={{
                                                display: "inline-block",
                                                boxSizing: "border-box",
                                                fontSize: "15px",
                                                fontWeight: "600",
                                                padding: "10px 20px",
                                                lineHeight: "1.4",
                                                letterSpacing: "0.2px",
                                                color: "#00adee",
                                                backgroundColor: "#FFFFFF",
                                                borderRadius: "8px",
                                                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                                                transition: "all 0.3s ease",
                                                cursor: "default"
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = "translateY(-4px)";
                                                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.15)";
                                                e.currentTarget.style.backgroundColor = "#f8f9fa";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = "translateY(0)";
                                                e.currentTarget.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.1)";
                                                e.currentTarget.style.backgroundColor = "#FFFFFF";
                                            }}>{item.trim()}</div>
                                    )}
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}

export default SectionDark;
